// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dgog","right":"styles_right__2Ir5z"};